/* Loja dos Patudos – chat de apoio com IA (widget leve, sem dependências).
 * Carregado por snippets/pp-chat.liquid com data-api="https://…/api/chat".
 * Guarda a conversa só na sessão do browser (sessionStorage).            */
(function () {
  'use strict';
  var root = document.getElementById('pp-chat');
  if (!root || root.dataset.ready) return;
  root.dataset.ready = '1';
  var API = root.getAttribute('data-api');
  if (!API) return;

  var KEY = 'pp-chat-v1';
  var state = { open: false, busy: false, messages: [] };
  try {
    var saved = JSON.parse(sessionStorage.getItem(KEY) || 'null');
    if (saved && Array.isArray(saved.messages)) state.messages = saved.messages.slice(-30);
  } catch (e) {}

  function sessionId() {
    var key = 'ppe-session';
    try {
      var s = sessionStorage.getItem(key);
      if (s) return s;
    } catch (e) {}
    var bytes = new Uint8Array(18);
    (window.crypto || window.msCrypto).getRandomValues(bytes);
    var id = btoa(String.fromCharCode.apply(null, bytes)).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/, '');
    try {
      sessionStorage.setItem(key, id);
    } catch (e) {}
    return id;
  }
  function save() {
    try {
      sessionStorage.setItem(KEY, JSON.stringify({ messages: state.messages.slice(-30) }));
    } catch (e) {}
  }
  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  /* texto → nós seguros: quebra de linha e links só para lojadospatudos.com e e-mail da loja */
  function richText(node, text) {
    var re = /(https:\/\/(?:www\.)?lojadospatudos\.com[^\s)]*|lm@atlasinvencivel\.pt|\*\*[^*]+\*\*)/g;
    String(text)
      .split('\n')
      .forEach(function (line, i) {
        if (i) node.appendChild(document.createElement('br'));
        var last = 0,
          m;
        while ((m = re.exec(line))) {
          if (m.index > last) node.appendChild(document.createTextNode(line.slice(last, m.index)));
          var t = m[0];
          if (t.indexOf('**') === 0) {
            node.appendChild(el('strong', null, t.slice(2, -2)));
          } else {
            var a = el('a', null, t.replace(/^https:\/\/(www\.)?/, ''));
            a.href = t.indexOf('@') > 0 && t.indexOf('http') !== 0 ? 'mailto:' + t : t.replace(/[.,;:]+$/, '');
            node.appendChild(a);
          }
          last = m.index + t.length;
        }
        if (last < line.length) node.appendChild(document.createTextNode(line.slice(last)));
      });
  }

  /* ---------- UI ---------- */
  var btn = el('button', 'pp-chat__btn');
  btn.type = 'button';
  btn.setAttribute('aria-label', 'Abrir o chat de apoio');
  btn.setAttribute('aria-expanded', 'false');
  btn.innerHTML =
    '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path fill="currentColor" d="M12 3C6.5 3 2 6.9 2 11.7c0 2.4 1.1 4.6 3 6.2L4 21.5l4.3-2.1c1.2.4 2.4.6 3.7.6 5.5 0 10-3.9 10-8.7S17.5 3 12 3z"/></svg>';

  var panel = el('div', 'pp-chat__panel');
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-label', 'Chat de apoio da Loja dos Patudos');
  panel.hidden = true;

  var head = el('div', 'pp-chat__head');
  var title = el('div', 'pp-chat__title');
  title.appendChild(el('strong', null, 'Apoio Loja dos Patudos'));
  title.appendChild(el('span', null, 'Assistente com IA · respostas na hora'));
  var close = el('button', 'pp-chat__close', '×');
  close.type = 'button';
  close.setAttribute('aria-label', 'Fechar o chat');
  head.appendChild(title);
  head.appendChild(close);

  var list = el('div', 'pp-chat__list');
  list.setAttribute('aria-live', 'polite');

  var chips = el('div', 'pp-chat__chips');
  ['Quanto tempo demora a entrega?', 'Chega antes do Natal?', 'Onde está a minha encomenda?', 'Como funciona o Estúdio?'].forEach(function (q) {
    var c = el('button', 'pp-chat__chip', q);
    c.type = 'button';
    c.addEventListener('click', function () {
      send(q);
    });
    chips.appendChild(c);
  });

  var form = el('form', 'pp-chat__form');
  var input = el('textarea', 'pp-chat__input');
  input.rows = 1;
  input.maxLength = 1000;
  input.placeholder = 'Escreve a tua pergunta…';
  input.setAttribute('aria-label', 'Mensagem');
  var sendBtn = el('button', 'pp-chat__send', 'Enviar');
  sendBtn.type = 'submit';
  form.appendChild(input);
  form.appendChild(sendBtn);

  var foot = el('div', 'pp-chat__foot');
  foot.appendChild(
    document.createTextNode('Respostas geradas por IA. Não partilhes dados de pagamento. Se for preciso, passamos à equipa por e-mail. '),
  );
  var priv = el('a', null, 'Privacidade');
  priv.href = '/policies/privacy-policy';
  foot.appendChild(priv);

  panel.appendChild(head);
  panel.appendChild(list);
  panel.appendChild(chips);
  panel.appendChild(form);
  panel.appendChild(foot);
  root.appendChild(panel);
  root.appendChild(btn);

  function bubble(role, text) {
    var b = el('div', 'pp-chat__msg pp-chat__msg--' + role);
    richText(b, text);
    list.appendChild(b);
    list.scrollTop = list.scrollHeight;
    return b;
  }
  function render() {
    list.textContent = '';
    bubble('assistant', 'Olá! 🐾 Sou o assistente da Loja dos Patudos. Posso ajudar com prazos, portes, trocas, o Estúdio, os nossos produtos ou o estado da tua encomenda.');
    state.messages.forEach(function (m) {
      bubble(m.role, m.content);
    });
    chips.hidden = state.messages.length > 0;
  }
  function setOpen(v) {
    state.open = v;
    panel.hidden = !v;
    btn.setAttribute('aria-expanded', String(v));
    root.classList.toggle('is-open', v);
    if (v) {
      render();
      setTimeout(function () {
        input.focus();
      }, 50);
    }
  }
  btn.addEventListener('click', function () {
    setOpen(!state.open);
  });
  close.addEventListener('click', function () {
    setOpen(false);
    btn.focus();
  });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && state.open) setOpen(false);
  });
  input.addEventListener('keydown', function (e) {
    if (e.key === 'Enter' && !e.shiftKey) {
      e.preventDefault();
      form.requestSubmit ? form.requestSubmit() : send(input.value);
    }
  });
  form.addEventListener('submit', function (e) {
    e.preventDefault();
    send(input.value);
  });

  function send(text) {
    text = String(text || '').trim();
    if (!text || state.busy) return;
    input.value = '';
    chips.hidden = true;
    state.messages.push({ role: 'user', content: text.slice(0, 1000) });
    save();
    bubble('user', text);
    state.busy = true;
    sendBtn.disabled = true;
    var typing = bubble('assistant', '…');
    typing.classList.add('is-typing');
    fetch(API, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'X-PP-Session': sessionId() },
      body: JSON.stringify({ messages: state.messages.slice(-16), page: location.pathname }),
    })
      .then(function (r) {
        return r.json().then(function (d) {
          return { ok: r.ok, d: d };
        });
      })
      .then(function (res) {
        typing.remove();
        var reply = res.ok && res.d && res.d.reply ? res.d.reply : (res.d && res.d.message) || 'Não consegui responder agora. Escreve para lm@atlasinvencivel.pt.';
        if (res.ok) {
          state.messages.push({ role: 'assistant', content: reply });
          save();
        }
        bubble('assistant', reply);
      })
      .catch(function () {
        typing.remove();
        bubble('assistant', 'Sem ligação de momento. Tenta de novo ou escreve para lm@atlasinvencivel.pt.');
      })
      .then(function () {
        state.busy = false;
        sendBtn.disabled = false;
      });
  }

  /* só mostra o botão se o chat estiver ligado no servidor */
  fetch(API, { method: 'GET' })
    .then(function (r) {
      return r.json();
    })
    .then(function (d) {
      if (d && d.enabled) root.hidden = false;
    })
    .catch(function () {});
})();
